import { Popup } from 'devextreme-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { DxReportViewer } from 'devexpress-reporting/dx-webdocumentviewer';
import * as ko from 'knockout';
import { ReportStruct, ReportType } from '../../../types/types.reports';
//import { UseApiResults } from '../../../api/api.results';
//import { ResultEstadoResult, SysIResultados } from '../../../types/types.orders';
//import { newToast } from '../..';
import deCore from '../../../localization/dx-analytics-core.es.json';
import deRep from '../../../localization/dx-reporting.es.json';

export const ModalReportPreview = ({ idOrd, visible, setVisible, reportName }: { idOrd: number; visible: boolean; setVisible: (value: boolean) => void; reportName: string }) => {
  const viewerRef = useRef<HTMLDivElement>(null);
  //const { getResults } = UseApiResults();
  const [requestOptions, setRequestOptions] = useState({
    host: '',
    invokeAction: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/config.json');
        const data = await response.json();

        //const resCurrentResult = await getResults();
        //const myData: SysIResultados[] = resCurrentResult.data as SysIResultados[];
        setRequestOptions({ host: `${data.apiUrl}/`, invokeAction: 'DXXRDV' });
      } catch (error) {
        console.error('Error fetching config data:', error);
      }
    };
    if (visible) {
      fetchData();
    }
  }, [visible]);

  useEffect(() => {
    if (!viewerRef.current || idOrd === -1 || !requestOptions.host || !visible) {
      return;
    }

    const myReport: ReportStruct = { Name: reportName, Type: ReportType.System, Data: [idOrd] };
    const reportUrl = ko.observable(JSON.stringify(myReport));
    const viewer = new DxReportViewer(viewerRef.current, {
      reportUrl,
      requestOptions,
      callbacks: {
        CustomizeMenuActions: (s, e) => {
          var search = e.Actions.find((x) => x.id === 'dxxrp-search');
          if (search) {
            search.visible = false;
          }
          var editingFields = e.Actions.find((x) => x.id === 'dxxrp-highlight-editing-fields');
          if (editingFields) {
            editingFields.visible = false;
          }

          var exportMenu = e.Actions.find((x) => x.id === 'dxxrp-export-menu');
          if (exportMenu) {
            exportMenu.visible = false;
          }

          var printPagePv = e.Actions.find((x) => x.id === 'dxxrp-print-page');
          if (printPagePv) {
            printPagePv.visible = false;
          }

          var printPage = e.Actions.find((x) => x.id === 'dxxrp-print');
          if (printPage) {
            printPage.visible = false;
          }
        },
        CustomizeExportOptions: (s, e) => {
          e.HideExportOptionsPanel();
        },

        CustomizeLocalization: (s, e) => {
          e.LoadMessages(deCore);
          e.LoadMessages(deRep);
          s.UpdateLocalization({
            'Preview Parameters': 'Parámetros',
            Reset: 'Limpiar',
          });
        },
      },
    });
    viewer.render();
    return () => {
      try {
        viewer.dispose();

        if (viewerRef.current) {
          ko.cleanNode(viewerRef.current);
          viewerRef.current.innerHTML = '';
        }
      } catch (error) {
        console.warn('Error limpiando el visor de reportes:', error);
      }
    };
  }, [idOrd, requestOptions]);

  const handleVisible = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <Popup visible={visible} fullScreen={true} onHidden={handleVisible} title='Previsualizador Reporte de resultados' showCloseButton={true}>
      <div style={{ width: '100%', height: '100%' }}>
        <div ref={viewerRef}></div>
      </div>
    </Popup>
  );
};
